export default __webpack_public_path__ + "static/media/order.fbcf4d46.svg";